import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { constants, snowplow } from 'common/helpers'

import toggleOpen from 'decorators/toggleOpen'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import Link from 'components/_new/typography/Link/Link'

import messages from './messages'


class HintForPremium extends PureComponent {

  static propTypes = {
    children: PropTypes.node,
    toggle: PropTypes.func, // @toggleOpen
    isToggleActive: PropTypes.bool, // @toggleOpen
    placement: PropTypes.string.isRequired,
    className: PropTypes.string,
    // TODO rethink styling here
    buttonTitle: PropTypes.object,
    typeGroup: PropTypes.string,
  }

  static defaultProps = {
    buttonTitle: messages.button,
  }

  state = {
    disableEvent: false,
  }

  handleClick = () => {
    const { disableEvent } = this.state
    const { toggle, placement } = this.props

    toggle()

    if (!disableEvent) {
      snowplow.track(constants.snowplowEvents.premiumProductDescriptionClick, {
        placement,
      })

      this.setState({ disableEvent: true })
    }
  }

  render() {
    const { isToggleActive, className, buttonTitle, typeGroup } = this.props

    const descriptionMessage = typeGroup === constants.productTypeGroups.perfume
      ? messages.descFragrances
      : messages.descProducts

    return (
      <div className={className}>
        <Box mt="4">
          <Link message={buttonTitle} onClick={this.handleClick} />
        </Box>
        {
          isToggleActive && (
            <Box mt="4">
              <Text
                message={descriptionMessage}
                color="gray"
                size="14-24"
                html
              />
              <Box mt="4">
                <Text
                  message={messages.bottomText}
                  color="gray"
                  size="14-24"
                />
              </Box>
            </Box>
          )
        }
      </div>
    )
  }
}


export default toggleOpen()(HintForPremium)
